export default {
  account: {
    search: {
      userAcct: '用户账号',
      userName: '用户姓名',
      userAccountPlaceholder: '请输入用户账号',
      personNamePlaceholder: '请输入用户姓名',
    },
    table: {
      userAccount: '用户账号',
      personName: '用户姓名',
      personSex: '性别',
      phone: '手机号',
      email: '邮箱',
      startValidityTime: '有效期开始时间',
      endValidityTime: '有效期结束时间',
      remark: '备注',
      inoutFlag: '内外部标识',
    },
    insertTitle: '新增账号',
    userAcct: '用户姓名',
    userAcctPlaceholder: '请选择用户',
    accountName: '用户账号',
    accountNamePlaceholder: '请输入用户账号',
    userAcctNotEmpty: '用户账号不能为空',
    phone: '手机号',
    phonePlaceholder: '请输入手机号',
    email: '邮箱',
    emailPlaceholder: '请输入邮箱',
    sex: '性别',
    sexPlaceholder: '请选择性别',
    isAdmin: '是否管理员',
    isAdminPlaceholder: '请选择',
    startValidityTime: '有效期起',
    endValidityTime: '有效期止',
    remark: '备注',
    deleteTips: '请选择要删除的账号',
    editTitle: '修改账号',
    editPassword: '重置密码',
    newPassword: '新密码',
    newPasswordEmpty: '请输入新密码',
    newPasswordEmptyOne: '密码需包含英文和数字，长度最少8位',
    newPasswordEmptyTwo: '新密码只能输入字母和数字',
    againNewPasswordEmpty: '请再次输入密码',
    againNewPasswordEmptys: '两次密码必须一致',
    againNewPassword: '再次输入密码',
    assignRoleTips: '请选择一条记录进行指派角色',
    assignRoleTitle: '指派角色',
    startTimePlaceholder: '请选择有效期开始时间',
    endTimePlaceholder: '请选择有效期结束时间',
    reamrkPlaceholder: '请输入备注',
  },
};
